import {forwardRef} from 'react';
import classNames from 'classnames';

const LocationManagerList = forwardRef(({children, onDelete, className, ...props}, ref) => (
    <ul className={classNames('location-manager-list', className)} ref={ref} {...props}>
        {children}
    </ul>
));

export default LocationManagerList;
